<!--TODO - wrap long template name-->
<!--TODO - suggest revenues/expenses [based on the industry]-->
<style>
  /*
  .shouldShowBelowFold-container-1 {
    display: none;
    @media (min-width: 800px) {
      display: inherit;
    }
  }

   */
  .shouldShowBelowFold-container-2 {
    text-align: center;
    margin: 30px 0;
    div {
      display: inline-block;
    }
  }

  .static-gallery-container {
    position:relative;
    max-width: 800px;
    margin: 0 auto;
    @media (min-width: 800px) {
      //padding-top: 40px;
    }
  }


</style>

<template>
  <div class="static-gallery-container">
    <div
      v-if="!this.$store.state.templateGallery.length"
      style="text-align: center;"
    >
      <v-progress-circular
        color="red"
        :size="30"
        :width="3"
        indeterminate
        class="v-progress-circular--visible"
      ></v-progress-circular>
    </div>

    <div v-if="this.$store.state.templateGallery.length">
<!--      <div class="shouldShowBelowFold-container-1">-->
<!--        <v-switch-->
<!--          style="position: absolute; top: -60px; right: 0;"-->
<!--          v-model="shouldShowBelowFold"-->
<!--          :label="translate('ui_show_below_fold')"-->
<!--        ></v-switch>-->
<!--      </div>-->

      <v-row style="position: relative;">
        <TemplateGalleryItem v-for="(template, i) in aboveFoldTemplates" :key="i"  :template="template" templateType="predefined"/>
      </v-row>

      <div class="shouldShowBelowFold-container-2">
        <v-switch
          v-model="shouldShowBelowFold"
          :label="translate('ui_show_below_fold')"
        ></v-switch>
      </div>

      <div v-if="shouldShowBelowFold">
        <v-row>
          <TemplateGalleryItem v-for="(template, i) in predefinedBelowFoldTemplates" :key="i"  :template="template" templateType="predefined"/>
        </v-row>

        <div v-if="userPublishedBelowFoldTemplates.length">
          <div class="home-container__prompt" style="margin: 40px 0;">
            {{ translate('ui_add_new_template_intro3') }}
          </div>
    <!--
          <v-row>
            <v-col v-for="(template, i) in userPublishedBelowFoldTemplates" :key="i" cols="6" md="3" lg="3">
              <TemplateGalleryItem :template="template" templateType="userPublished"/>
            </v-col>
          </v-row>
     -->
        </div>

      </div>

      <v-alert
        v-if="this.$store.state.loggedin && userHasPublishedTemplates && !this.$store.state.user.displayName"
        outlined
        type="info"
        border="left"
        style="margin-top: 40px;"
      >
        {{ translate('ui_settings_add_displayname_prompt') }}
        <router-link to="/settings">{{ translate('ui_settings_add_displayname') }}</router-link>
      </v-alert>
    </div>

  </div>
</template>

<script>
import TemplateGalleryItem from '@/components/gallery/TemplateGalleryItem';
// mixins
import Mixin from '../../mixins/mixin';

export default {
  components: { TemplateGalleryItem },
  props: {},
  data: () => ({
    shouldShowBelowFold: false,
    foldCutOff: 5,
  }),
  mixins: [Mixin],
  computed: {
    aboveFoldTemplates() {
      return this.$store.state.templateGallery.toSpliced(this.foldCutOff);
    },
    belowFoldTemplates() {
      return this.$store.state.templateGallery.toSpliced(0, this.foldCutOff);
    },
    predefinedBelowFoldTemplates() {
      return this.belowFoldTemplates.filter((template) => !template.userId);
    },
    userPublishedBelowFoldTemplates() {
      return [];
      // return this.belowFoldTemplates.filter((template) => template.userId);
    },
    // userHasPublishedTemplates() {
    //   return this.userPublishedBelowFoldTemplates.filter((template) => {
    //     // eslint-disable-next-line
    //     const userId = this.$store.state.user._id;
    //     return template.userId === userId;
    //   }).length > 0;
    // },
    addNewTemplate() {
      const { language } = this.$store.state.user.settings;
      let result = '';
      if (this.$store.state.languages) {
        result = this.translate('ui_add_new_template_btn', language);
      }
      return result;
    },
  },
};
</script>
